<template>
    <div class="mt-5 mb-5 pt-5 pb-5 w-100">
        <p class="uppercase title-big t-white150 text-center no-select">Server error</p>
    </div>
</template>
